module.exports = __webpack_public_path__ + "img/item_morningglow_ida_2024@2x.980ccb5.webp";